import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import {
    APP_INITIALIZER,
    DEFAULT_CURRENCY_CODE,
    LOCALE_ID,
    NgModule,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { MatInputModule } from '@angular/material/input';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { FuseModule } from '@fuse';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { FuseConfigModule } from '@fuse/services/config';
import { IonicModule } from '@ionic/angular';
import { CodeEditorModule } from '@ngstack/code-editor';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { appConfig } from 'app/core/config/app.config';
import { CoreModule } from 'app/core/core.module';
import { LayoutModule } from 'app/layout/layout.module';
import { mockApiServices } from 'app/mock-api';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MarkdownModule } from 'ngx-markdown';
import { AuthService } from './core/auth/auth.service';
import { IframeCotacoesComponent } from './iframe-cotacoes/iframe-cotacoes.component';
import { getPortuguesePaginatorIntl } from './pt-br-paginator-intl';
import { DominioService } from './shared/services/dominio.service';

registerLocaleData(ptBr);

function appInitializer(authService: AuthService) {
  return () =>
    new Promise((resolve) => {
      //@ts-ignore
      authService.setUserValue().subscribe().add(resolve);
    });
}

function getDominio(_service: DominioService) {
  return () =>
    new Promise((resolve) => {
      //@ts-ignore
      _service.getDominio().subscribe().add(resolve);
    });
}

const routerConfig: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: 'enabled',
};

@NgModule({
  declarations: [AppComponent, IframeCotacoesComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),

    // Fuse, FuseConfig & FuseMockAPI
    FuseModule,
    FuseConfigModule.forRoot(appConfig),
    FuseMockApiModule.forRoot(mockApiServices),

    // Core module of your application
    CoreModule,

    // Layout module of your application
    LayoutModule,

    // 3rd party modules that require global configuration via forRoot
    MarkdownModule.forRoot({}),

    IonicModule.forRoot(),

    MatSelectModule,
    LeafletModule,
    NgApexchartsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CodeEditorModule.forRoot({
      baseUrl: '/assets/monaco-editor/min'
    }),
    MatAutocompleteModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: getDominio,
      multi: true,
      deps: [DominioService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide: MatPaginatorIntl, useValue: getPortuguesePaginatorIntl() },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
